import React from 'react';
import { Button, Radio, Spin, Typography } from "antd";
import { AutoComplete, Select } from "../../../components/shared/OptionWidthControl";
import { useMiscOptions } from '../viewmodels/useMiscOptions';

export function MiscOptionsError({ state }) {
  return state.error ? <span role="alert"><Typography.Text type="danger">Couldn't load options</Typography.Text> <Button size="small" type="link" onClick={state.retry}>Retry</Button></span> : null;
}
function Control({ mode, allowedValues, value, disabled, control, forwardedRef, ...props }) {
  const state = useMiscOptions(mode, value, allowedValues);
  const Component = control;
  return <><Component {...props} ref={forwardedRef} value={value} disabled={state.loading || state.error ? true : disabled}
    {...(control === Select ? { loading: state.loading } : {})} options={state.options} /><MiscOptionsError state={state} /></>;
}
export const MiscSelect = React.forwardRef((props, ref) => <Control {...props} control={Select} forwardedRef={ref} />);
export const MiscRadio = React.forwardRef((props, ref) => <Control {...props} control={Radio.Group} forwardedRef={ref} />);
export const MiscAutoComplete = React.forwardRef((props, ref) => <Control {...props} control={AutoComplete} forwardedRef={ref} />);
export function MiscLabel({ mode, value }) {
  const state = useMiscOptions(value == null || value === '' ? null : mode, value);
  if (value == null || value === '') return <>—</>;
  return state.error ? <MiscOptionsError state={state} /> : state.loading ? <Spin size="small" /> : <>{state.label(value)}</>;
}
